import React from 'react';
import './photodetail.scss';
import  Globals from '../../api' ;
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import Rightbar from "../../components/Rightbar/Rightbar";
// import MustRead from '../../components/MustRead/Mustread';

export default class PhotoDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           Gallerydata : [],
           videos : [],
           meta : [] ,
           title : [],
           meta_keywords : [],
           meta_description : [],
           Rightbar : [],
           AdData : []
           
         };
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      } 
      getRightbar(){
        const url= Globals.Rightbar_api+"/news";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }  
      componentDidMount() {
    //photo-gallery-new logic
    let url = window.location.pathname;
    if(url == "/photo-gallery")
    url = "/photo-gallery-new";
    url = url.replace("/photo-gallery/", "/photo-gallery-new/");
    //photo-gallery-new logic end
       // let URI = window.location.pathname;
        const Dataurl= Globals.language_based_api+url;
           fetch(Dataurl)
           .then((res) => res.json())
           .then((data) => {
             
               this.setState({
                 Gallerydata : data.Contents,
                 meta : data.Meta ,
                 title : data.Title,
                 meta_keywords : data.Meta.keywords.Attributes.content,
                 meta_description : data.Meta.description.Attributes.content
               })
           }) 
        this.getRightbar();
        this.getAds();
         }

    render() {
        let Gallery = this.state.Gallerydata;
        //next page logic
    let NextPageData = Gallery.filter(
      (x) => x.Type == "AutoLoadPage"
    );
    var pageValue = [];
    const Nextpager = NextPageData.map((item) => {
      pageValue = item.PageUrl;
    });
    const nextPage = () => { 
      window.location = pageValue;  
    }
   //next page logic end
                let menuListData = Gallery.filter((x) => x.Type == "PhotoGalleryNavigation");

                var catsvalue = [];
                const CatArray = menuListData.map((item) => {
                catsvalue = item.Items;
                });
                const menuArr = catsvalue.map((item, i) => (
                <li>
                <a href={item.Url} className={item.Active == true ? "active" : ""}>
                {item.Title}
                </a>
                </li>
                ));
      //   const nextPage = () => { 
      //       let nextPageUrl = this.state.Gallerydata;
      //       let index = (nextPageUrl.length==7?4:5);
      //       window.location = nextPageUrl[index].PageUrl;  
      // }
     
        let  GalleryData = Gallery.filter((x)=>x.Type === "PhotoGallery");
        let  RelatedGalleryData = Gallery.filter((x)=>x.Type === "SingleCategoryPhotoGalleryList");
       // console.log("RelatedGalleryData"+RelatedGalleryData.Title);

         const GalleryMain = GalleryData.map((item , i)  =>
         <div className="photo_detail_wrap">
          <div className="photo_d_title">
           <h2>{item.Title}</h2>
               <ul className="p_d_social">
                        <li><a href={`https://www.facebook.com/share.php?u=${item.ShareUrl}&title=${item.Title}`} target="_blank" className="art_fb_icon"></a></li>
                        <li><a href={`https://twitter.com/intent/tweet?status=${item.Title}+${item.ShareUrl}`} className="art_tw_icon" target="_blank"></a></li>
                        <li><a href={`https://api.whatsapp.com/send?text=${item.Title}/${item.ShareUrl}?contentType=photogallery`} className="art_whapp_icon" target="_blank"></a></li>
                </ul>
         </div> 
         <div className="photo_d_content">
         <p>{item.Items[0]['Title']} </p>
         <div className="photo_gall_list">
        <SimpleReactLightbox>
          <SRLWrapper >   
          {item.Items.map((item, i ) => 
         <a href={`${item.Image}`} data-attribute="SRL">
         <img src={`${item.Image}`}  />
          </a>
           )}
        </SRLWrapper>
        </SimpleReactLightbox>
        </div>
       </div>
       </div>
         );
         
         const RelatedGallery = RelatedGalleryData.map((item , i)  =>
         <div className="news_widget_panel">
          <div className="n_w_p_head">
             <h2><label>{item.Title}</label></h2>
          </div> 
          <div className="n_w_p_body">
          <div className="pho_listing">
          {item.Items.map((item, i ) => 
          <div className="p_col">
          <div className="photos_list_block">
          <a href={item.Url}><div className="photo_l_img">
                  <img src={item.Image} />
                  <label className="photo_l_img_count">{item.ImageCount}</label>
              </div>
              </a>
              <div className="photo_l_cont">
                  <h2><a href={item.Url}>{item.Title}</a></h2>
                  {/* <a href="#" className="photo_category">समाचार</a> */}
              </div>
          </div>
      </div>
           )}
         </div>  
        </div>
       </div>
         );
        return (
            <div>
                
                <div className="container padding15">
                    <div className="row">
                        <div className="col">
                        <div className="photo_gall_tabs">
                        <ul>{menuArr}</ul>
                        </div>
                            <ul className="wdbreadcrumb">
                                <li><a href="/photo-gallery">Photo Gallery</a></li>
                                {/* <li><a href="#">सिनेमा टीवी</a></li> */}
                                <li>{this.state.title}</li>
                            </ul>
                            {GalleryMain}
                            <div className="m-b-20"></div>
                            <div className="ads_block m-t-10 m-b-20">
                            {/* <img src={ads1} /> */}
                            </div>
                            {RelatedGallery}
                            <button style= {{width : "150px" , marginTop : "27px",marginLeft : "370px"}}className="btn btn-block btn-outline-primary" onClick={nextPage}>Load More...</button>
            
                        </div>
                        <div className="col right_side_bar">
                        <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

